import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { HipaaCompliance } from "stores/ApplicationFilters/Filters/HipaaCompliance";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const HipaaComplianceChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const hipaaComplianceValue = applicationFiltersStore.hipaaCompliance;
    if (hipaaComplianceValue === undefined || hipaaComplianceValue === null)
        return null;

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() =>
                applicationFiltersStore.setHipaaCompliance(undefined)
            }
        >
            HIPAA: {HipaaCompliance.toString(hipaaComplianceValue)}
        </AppliedFilterChip>
    );
});
